import DatabaseService from 'services/DatabaseService.js';
import {SET_HISTORY,
        ADD_USERCHALLENGES} from 'actions/types';
import {isHistoryListLoaded,
        getHistory}  from 'reducers/userChallenges.js'
import {addCategories, addCategory} from 'actions/categories.js';
import {addChallenges, addChallenge, fetchChallenge}  from 'actions/challenges.js'

//Action Creators
export const setHistory = (userChallenges) => {
    return { type:SET_HISTORY, userChallenges:userChallenges};
}
export const addUserChallenges = (userChallenges) => {
    return { type:ADD_USERCHALLENGES, userChallenges:userChallenges};
}



//helpers
export const processHistory = (dispatch, history) => {
    var userChallenges = history.map(c => c.userChallenge);
    var challenges = history.map(c => ({...c, userChallenge : null}));
    dispatch(addCategories(challenges.map(c=>c.category).filter(cat=>cat!=null)));
    dispatch(addChallenges(challenges));
    dispatch(setHistory(userChallenges));
}


//Thunks
export const fetchHistory = (force) => (dispatch, getState) => {
    var challenge = null;
    if(!force) {
        var state = getState();
        if(isHistoryListLoaded(state.userChallenges)) {
            return Promise.resolve(getHistory(state.userChallenges));
        }
    }

    return new Promise(function(resolve, reject) {
        DatabaseService.getTimeline({history:true}).then( //timeline
            function(result) {
                console.log('fetchHistory', result);
                var history = result.history;
                processHistory(dispatch, history);
                resolve(history); 
            },
            function(error) {
                console.error(error);
                reject(error); 
            });
    });
}


/*
    Note that this takes a challengeId
*/
export const completeChallenge = (challengeId, userChallenge, params) => (dispatch, getState) => {

    return dispatch(fetchChallenge(challengeId))
            .then((challenge)=>{
                var category = challenge.category;
                return new Promise(function(resolve, reject) {
                    DatabaseService.completeChallenge(challengeId, userChallenge, params).then(
                        function(result){ 
                            console.log("completeChallenge result: ", result);
                            //reshape result to format returned by timeline api
                            var userChallenge = result.userChallenge;
                            var userCategory = userChallenge.userCategory;
                            var newCategory = {...category, userCategory:userCategory};
                            //invert userChallenge.challenge to challenge.userChallenge =)
                            var newChallenge = {...challenge, userChallenge:{...userChallenge, challenge:null, userCategory:null}}; 
                            if(newCategory) {
                                dispatch(addCategory(newCategory));
                            }
                            dispatch(addChallenge(newChallenge));
                            dispatch(addUserChallenges([userChallenge]));
                            resolve(result);
                        },
                        function(error){ 
                            console.error(error);
                            reject(error); 
                        });
                });
            });
}



// WEBPACK FOOTER //
// ./src/actions/userChallenges.js